"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Widget", {
    enumerable: true,
    get: function() {
        return Widget;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Card = require("../Card");
const _NoResults = require("./NoResults");
const _Theme = require("../../contexts/Theme");
const _WidgetLoadingContent = require("./WidgetLoadingContent");
const _StickyContainer = require("../Sticky/StickyContainer");
const _StickyElement = require("../Sticky/StickyElement");
const _Tooltip = require("../Tooltip/Tooltip");
const _adminicons = require("../../admin-icons");
const _AdminButton = require("../Button/AdminButton");
const _useForwardedRef = require("../../util/useForwardedRef");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const headerHeight = 32;
const Widget = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, title, isLoading, noResults, buttonText = "Back To Top", disableOverflow, ...props } = param;
    const { colors, spacers, zIndexes } = (0, _Theme.useTheme)();
    const [stickyHeader, setStickyHeader] = (0, _react.useState)(false);
    const innerRef = (0, _useForwardedRef.useForwardedRef)(ref);
    const handleScroll = (0, _react.useCallback)((e)=>{
        setStickyHeader(e.currentTarget.scrollTop > headerHeight);
    }, []);
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const content = (0, _react.useMemo)(()=>{
        if (isLoading === true) {
            return /*#__PURE__*/ _react.default.createElement("div", {
                className: _style.default.dynamic([
                    [
                        "f40233b56d19f3be",
                        [
                            spacers.s5
                        ]
                    ]
                ]) + " " + "loading"
            }, /*#__PURE__*/ _react.default.createElement(_WidgetLoadingContent.WidgetLoadingContent, {
                height: 80
            }), /*#__PURE__*/ _react.default.createElement(_WidgetLoadingContent.WidgetLoadingContent, {
                height: 80
            }), /*#__PURE__*/ _react.default.createElement(_WidgetLoadingContent.WidgetLoadingContent, {
                height: 80
            }), /*#__PURE__*/ _react.default.createElement(_WidgetLoadingContent.WidgetLoadingContent, {
                height: 80
            }), /*#__PURE__*/ _react.default.createElement(_style.default, {
                id: "f40233b56d19f3be",
                dynamic: [
                    spacers.s5
                ]
            }, ".loading.__jsx-style-dynamic-selector{padding:".concat(spacers.s5, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px}")));
        }
        if ((noResults === null || noResults === void 0 ? void 0 : noResults.hasNoResults) === true && props.icon != null) {
            return /*#__PURE__*/ _react.default.createElement(_NoResults.NoResults, {
                text: noResults.text,
                icon: props.icon
            });
        }
        return children;
    }, [
        isLoading,
        children,
        noResults,
        props.icon,
        spacers
    ]);
    return /*#__PURE__*/ _react.default.createElement(_StickyContainer.StickyContainerWithRef, {
        ref: innerRef
    }, /*#__PURE__*/ _react.default.createElement(_Card.Card, {
        ...props,
        ref: innerRef,
        style: {
            height: "100%",
            overflowY: isLoading === true || disableOverflow === true ? "hidden" : "auto",
            boxShadow: "".concat(spacers.s0, " ").concat(spacers.s2, " ").concat(spacers.s3, " ").concat(spacers.s0, " rgba(0, 0, 0, 0.05)"),
            position: "relative"
        },
        onScroll: handleScroll
    }, /*#__PURE__*/ _react.default.createElement(_StickyElement.StickyElement, null, (param)=>{
        let { ref: headerRef } = param;
        return /*#__PURE__*/ _react.default.createElement("div", {
            ref: headerRef,
            style: {
                zIndex: zIndexes.dropdown + 1,
                borderBottom: stickyHeader ? "solid 1px ".concat(colors.border) : "none"
            },
            className: _style.default.dynamic([
                [
                    "8e4c7cd9d1aa07e7",
                    [
                        colors.white,
                        spacers.s4,
                        spacers.s5,
                        spacers.s4,
                        spacers.s4,
                        colors.transparent.black[60],
                        colors.white,
                        colors.grayscale[10],
                        spacers.s0,
                        spacers.s5,
                        spacers.s3,
                        spacers.s2,
                        colors.dark
                    ]
                ]
            ]) + " " + "stickyHeader"
        }, /*#__PURE__*/ _react.default.createElement("div", {
            className: _style.default.dynamic([
                [
                    "8e4c7cd9d1aa07e7",
                    [
                        colors.white,
                        spacers.s4,
                        spacers.s5,
                        spacers.s4,
                        spacers.s4,
                        colors.transparent.black[60],
                        colors.white,
                        colors.grayscale[10],
                        spacers.s0,
                        spacers.s5,
                        spacers.s3,
                        spacers.s2,
                        colors.dark
                    ]
                ]
            ]) + " " + "stickyInner sticky-title"
        }, isLoading === true ? /*#__PURE__*/ _react.default.createElement(_WidgetLoadingContent.WidgetLoadingContent, {
            height: 20,
            width: 20,
            disableAnimation: true
        }) : props.icon != null && /*#__PURE__*/ _react.default.createElement(props.icon, {
            size: 20,
            className: "mr-3 sticky-title-icon",
            style: {
                color: colors.grayscale[60]
            }
        }), /*#__PURE__*/ _react.default.createElement("h2", {
            style: {
                opacity: stickyHeader ? 1 : 0
            },
            className: _style.default.dynamic([
                [
                    "8e4c7cd9d1aa07e7",
                    [
                        colors.white,
                        spacers.s4,
                        spacers.s5,
                        spacers.s4,
                        spacers.s4,
                        colors.transparent.black[60],
                        colors.white,
                        colors.grayscale[10],
                        spacers.s0,
                        spacers.s5,
                        spacers.s3,
                        spacers.s2,
                        colors.dark
                    ]
                ]
            ]) + " " + "transition"
        }, title)), /*#__PURE__*/ _react.default.createElement("div", {
            className: _style.default.dynamic([
                [
                    "8e4c7cd9d1aa07e7",
                    [
                        colors.white,
                        spacers.s4,
                        spacers.s5,
                        spacers.s4,
                        spacers.s4,
                        colors.transparent.black[60],
                        colors.white,
                        colors.grayscale[10],
                        spacers.s0,
                        spacers.s5,
                        spacers.s3,
                        spacers.s2,
                        colors.dark
                    ]
                ]
            ]) + " " + "stickyInner"
        }, /*#__PURE__*/ _react.default.createElement("span", {
            style: {
                opacity: stickyHeader ? 1 : 0,
                pointerEvents: stickyHeader ? "auto" : "none"
            },
            className: _style.default.dynamic([
                [
                    "8e4c7cd9d1aa07e7",
                    [
                        colors.white,
                        spacers.s4,
                        spacers.s5,
                        spacers.s4,
                        spacers.s4,
                        colors.transparent.black[60],
                        colors.white,
                        colors.grayscale[10],
                        spacers.s0,
                        spacers.s5,
                        spacers.s3,
                        spacers.s2,
                        colors.dark
                    ]
                ]
            ]) + " " + "transition"
        }, props.button), props.tooltip != null && /*#__PURE__*/ _react.default.createElement(_Tooltip.Tooltip, {
            title: props.tooltip,
            placement: "top"
        }, /*#__PURE__*/ _react.default.createElement("div", {
            style: {
                display: stickyHeader ? "none" : "inline-block"
            },
            className: _style.default.dynamic([
                [
                    "8e4c7cd9d1aa07e7",
                    [
                        colors.white,
                        spacers.s4,
                        spacers.s5,
                        spacers.s4,
                        spacers.s4,
                        colors.transparent.black[60],
                        colors.white,
                        colors.grayscale[10],
                        spacers.s0,
                        spacers.s5,
                        spacers.s3,
                        spacers.s2,
                        colors.dark
                    ]
                ]
            ])
        }, /*#__PURE__*/ _react.default.createElement(_adminicons.RiInformationLine, {
            style: {
                color: colors.medium,
                cursor: "pointer",
                display: "block"
            }
        }))), props.dropdownMenu != null && /*#__PURE__*/ _react.default.createElement("span", {
            className: _style.default.dynamic([
                [
                    "8e4c7cd9d1aa07e7",
                    [
                        colors.white,
                        spacers.s4,
                        spacers.s5,
                        spacers.s4,
                        spacers.s4,
                        colors.transparent.black[60],
                        colors.white,
                        colors.grayscale[10],
                        spacers.s0,
                        spacers.s5,
                        spacers.s3,
                        spacers.s2,
                        colors.dark
                    ]
                ]
            ]) + " " + "ml-3 dropdown"
        }, props.dropdownMenu)));
    }), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "8e4c7cd9d1aa07e7",
                [
                    colors.white,
                    spacers.s4,
                    spacers.s5,
                    spacers.s4,
                    spacers.s4,
                    colors.transparent.black[60],
                    colors.white,
                    colors.grayscale[10],
                    spacers.s0,
                    spacers.s5,
                    spacers.s3,
                    spacers.s2,
                    colors.dark
                ]
            ]
        ]) + " " + "header"
    }, isLoading === true ? /*#__PURE__*/ _react.default.createElement(_WidgetLoadingContent.WidgetLoadingContent, {
        height: 24,
        width: 160
    }) : /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("h1", {
        className: _style.default.dynamic([
            [
                "8e4c7cd9d1aa07e7",
                [
                    colors.white,
                    spacers.s4,
                    spacers.s5,
                    spacers.s4,
                    spacers.s4,
                    colors.transparent.black[60],
                    colors.white,
                    colors.grayscale[10],
                    spacers.s0,
                    spacers.s5,
                    spacers.s3,
                    spacers.s2,
                    colors.dark
                ]
            ]
        ])
    }, title), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "8e4c7cd9d1aa07e7",
                [
                    colors.white,
                    spacers.s4,
                    spacers.s5,
                    spacers.s4,
                    spacers.s4,
                    colors.transparent.black[60],
                    colors.white,
                    colors.grayscale[10],
                    spacers.s0,
                    spacers.s5,
                    spacers.s3,
                    spacers.s2,
                    colors.dark
                ]
            ]
        ]) + " " + "button-container"
    }, props.button))), content, /*#__PURE__*/ _react.default.createElement("div", {
        style: {
            position: "sticky",
            bottom: 10,
            pointerEvents: "none"
        },
        className: _style.default.dynamic([
            [
                "8e4c7cd9d1aa07e7",
                [
                    colors.white,
                    spacers.s4,
                    spacers.s5,
                    spacers.s4,
                    spacers.s4,
                    colors.transparent.black[60],
                    colors.white,
                    colors.grayscale[10],
                    spacers.s0,
                    spacers.s5,
                    spacers.s3,
                    spacers.s2,
                    colors.dark
                ]
            ]
        ]) + " " + "mt-3 p-3 d-flex align-items-center justify-content-center"
    }, stickyHeader && /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        variant: "primary",
        size: "md",
        style: {
            pointerEvents: "all"
        },
        onClick: ()=>{
            var _innerRef_current;
            (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }, /*#__PURE__*/ _react.default.createElement(_adminicons.RiArrowUpLine, {
        size: 16
    }), buttonText))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "8e4c7cd9d1aa07e7",
        dynamic: [
            colors.white,
            spacers.s4,
            spacers.s5,
            spacers.s4,
            spacers.s4,
            colors.transparent.black[60],
            colors.white,
            colors.grayscale[10],
            spacers.s0,
            spacers.s5,
            spacers.s3,
            spacers.s2,
            colors.dark
        ]
    }, ".stickyHeader.__jsx-style-dynamic-selector{position:-webkit-sticky;position:sticky;top:0;z-index:1;background:".concat(colors.white, ";padding:").concat(spacers.s4, " ").concat(spacers.s5, " ").concat(spacers.s4, " ").concat(spacers.s4, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:48px;gap:16px}.stickyHeader.__jsx-style-dynamic-selector h2.__jsx-style-dynamic-selector{text-transform:uppercase;font-size:12px;font-weight:500;line-height:24px;padding:0;margin:0;color:").concat(colors.transparent.black[60], ";white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}.transition.__jsx-style-dynamic-selector{-webkit-transition:opacity 100ms;-moz-transition:opacity 100ms;-o-transition:opacity 100ms;transition:opacity 100ms}.header.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-column-gap:16px;-moz-column-gap:16px;column-gap:16px;background:").concat(colors.white, ";border-bottom:solid 1px ").concat(colors.grayscale[10], ";padding:").concat(spacers.s0, " ").concat(spacers.s5, " ").concat(spacers.s3, "}.header.__jsx-style-dynamic-selector h1.__jsx-style-dynamic-selector{margin:0;font-weight:700;font-size:20px;line-height:24px;padding-bottom:").concat(spacers.s2, ";color:").concat(colors.dark, "}.stickyInner.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.sticky-title.__jsx-style-dynamic-selector{overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}.sticky-title-icon{min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content}.button-container.__jsx-style-dynamic-selector{min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content}.dropdown.__jsx-style-dynamic-selector{margin-right:-4px}")));
});
Widget.displayName = "Widget";

//# sourceMappingURL=Widget.js.map